import React, { useState, useEffect, useContext } from 'react';
import { string, bool, shape } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { Carousel } from '@thd-olt-component-react/carousel';

import './banner.style.scss';
import { makeApiRequest } from './request';

import {
  getSchema, isServer, haveProductsChanged, getSkus, getDefaultBanner, shouldMakeApiRequest
} from './helpers';

const SponsoredBanner = (props) => {
  const [lastRequestScenario, setLastRequestScenario] = useState({});
  const [hasData, setHasData] = useState(false);
  const { renderNewBanner = false } = useLayoutGroupProps({ props });
  const experienceContext = useContext(ExperienceContext);
  const { pageContext } = props;
  let { schema } = props;

  const defaultBannerInfo = getDefaultBanner(experienceContext);
  schema = getSchema({ schema, pageContext });
  const schemaId = schema + '__banner';

  useEffect(() => {
    if (renderNewBanner) {
      const isValidScenario = shouldMakeApiRequest({ lastRequestScenario, experienceContext, pageContext });

      if (isValidScenario) {
        setLastRequestScenario({
          url: window.location.pathname + window.location.search,
          skus: getSkus(pageContext)
        });

        makeApiRequest({
          schema, schemaId, experienceContext, pageContext, setHasData
        });
      }
    }
  }, [pageContext.data]);

  if (!renderNewBanner) {
    return null;
  }

  return (
    <div className="sponsored_banner_container" style={defaultBannerInfo.bgCss}>
      { !hasData && (
        <div id="default_banner_carousel" style={defaultBannerInfo.spacingCss}>
          <a href={defaultBannerInfo.href}>
            { /* eslint-disable-next-line */ }
            <img width="100%" src={defaultBannerInfo.imgSrc} style={{ position: 'absolute', top: 0, left: 0 }} />
          </a>
        </div>
      )}

      { hasData && (
        <Carousel multiItem={false} totalItems={2}>
          <div id="default_banner_carousel" style={defaultBannerInfo.spacingCss}>
            <a href={defaultBannerInfo.href}>
              { /* eslint-disable-next-line */ }
              <img width="100%" src={defaultBannerInfo.imgSrc} style={{ position: 'absolute', top: 0, left: 0 }} />
            </a>
          </div>
          <div id={schemaId} className="nucleus-banner" data-usenewimpressionlogic="true" />
        </Carousel>
      )}
    </div>
  );
};

SponsoredBanner.propTypes = {
  schema: string,
  pageContext: shape({
    label: string,
    data: shape(),
    keyword: string,
    isSearch: bool,
    isCategory: bool,
    isBrowse: bool
  }),
};

SponsoredBanner.defaultProps = {
  schema: '',
  pageContext: {},
};

export { SponsoredBanner };
